import { bindable } from 'aurelia-framework';

export class LogoImageCustomElement {
	@bindable logoText: string = '';
	@bindable useLogo: boolean = true;
	@bindable logoUrl: string = '';

	attached() {
		if (this.logoText == null)
			this.logoText = '';

		if (this.logoUrl == null)
			this.logoUrl = '';
	}
}